if (!customElements.get('product-form-99')) {
  customElements.define('product-form-99', class extends HTMLElement {});
}

class CartFlyout99 extends HTMLElement {
  constructor() {
    super();
    this.bodyEl = this.querySelector('.cart-flyout-99__body');
    this.itemsEl = this.querySelector('#CartFlyout99-Items');
    this.emptyEl = this.querySelector('#CartFlyout99-Empty');
    this.footerEl = this.querySelector('#CartFlyout99-Footer');
    this.errorsEl = this.querySelector('#CartFlyout99-Errors');
    this.loadingEl = this.querySelector('#CartFlyout99-Loading');
    this.subtotalEl = this.querySelector('#CartFlyout99-Subtotal');
    this.headerCountEl = this.querySelector('#CartFlyout99-HeaderCount');
    this.checkoutBtn = this.querySelector('#CartFlyout99-Checkout');
    this.recommendationsEl = this.querySelector('#CartFlyout99-Recommendations');
    this.recommendationsListEl = this.querySelector('#CartFlyout99-RecommendationsList');

    this.updateDebounced = this.debounce(this.updateLine.bind(this), 350);
    this.lastSeedProductId = null;
    this.lastAddedKey = null;

    this.bindClose();
    this.bindTriggers();
    this.bindAddToCartForms();
    this.bindItemEvents();
    this.bindRecommendationEvents();

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', () => {
        window.location.href = '/checkout';
      });
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  bindClose() {
    this.querySelectorAll('[data-cart-flyout-99-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') this.close();
    });
  }

  bindTriggers() {
    if (window.cartFlyoutEnabled === false) return;

    const openHandler = (e) => {
      e.preventDefault();
      this.fetchCart().then(() => this.open());
    };

    const selectors = [
      '#cart-icon-bubble',
      '.header-99__cart-link',
      '[data-cart-flyout-99-toggle]',
    ];

    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      el.setAttribute('role', 'button');
      el.setAttribute('aria-haspopup', 'dialog');
      el.addEventListener('click', openHandler);
    });
  }

  bindAddToCartForms() {
    document.addEventListener('submit', (e) => {
      if (window.cartFlyoutEnabled === false) return;

      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      const errorWrapper = form.closest('product-form-99')?.querySelector('.product-form__error-message-wrapper');
      const errorMessageEl = errorWrapper?.querySelector('.product-form__error-message');
      if (errorWrapper) errorWrapper.hidden = true;

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            if (errorWrapper && errorMessageEl) {
              errorMessageEl.textContent = data.description || data.message;
              errorWrapper.hidden = false;
            }
            this.showError(data.description || data.message);
            return this.fetchCart().then(() => this.open());
          }
          this.lastSeedProductId = data.product_id;
          this.lastAddedKey = data.key;
          return this.fetchCart().then(() => this.open());
        })
        .catch(() => {
          this.showError(window.cartStrings ? window.cartStrings.error : 'Something went wrong.');
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  bindItemEvents() {
    this.itemsEl.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');

      if (minus || plus) {
        const row = e.target.closest('.cart-flyout-99__item');
        const input = row.querySelector('input');
        let val = parseInt(input.value, 10) || 0;
        val = minus ? Math.max(0, val - 1) : val + 1;
        input.value = val;
        row.classList.add('is-updating');
        this.updateDebounced(row.dataset.key, val);
      }
    });

    this.itemsEl.addEventListener('change', (e) => {
      const input = e.target.closest('input[data-qty-input]');
      if (!input) return;
      const row = e.target.closest('.cart-flyout-99__item');
      const val = Math.max(0, parseInt(input.value, 10) || 0);
      row.classList.add('is-updating');
      this.updateDebounced(row.dataset.key, val);
    });
  }

  bindRecommendationEvents() {
    this.recommendationsListEl.addEventListener('click', (e) => {
      const sizePill = e.target.closest('[data-select-variant]');
      if (sizePill && !sizePill.disabled) {
        const card = sizePill.closest('[data-recommendation-product]');
        const addButton = card.querySelector('[data-add-recommendation]');
        const priceEl = card.querySelector('[data-recommendation-price]');

        card.querySelectorAll('[data-select-variant]').forEach((pill) => pill.classList.remove('is-selected'));
        sizePill.classList.add('is-selected');

        const isAvailable = sizePill.dataset.variantAvailable === 'true';
        addButton.dataset.variantId = sizePill.dataset.variantId;
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable ? 'Add' : 'Sold out';

        if (priceEl) priceEl.textContent = this.formatMoney(Number(sizePill.dataset.variantPrice));
        return;
      }

      const button = e.target.closest('[data-add-recommendation]');
      if (!button || button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.showError(data.description || data.message);
            button.disabled = false;
            button.textContent = originalText;
            return;
          }
          this.lastAddedKey = data.key;
          return this.fetchCart();
        })
        .catch(() => {
          this.showError(window.cartStrings ? window.cartStrings.error : 'Something went wrong.');
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  }

  fetchCart() {
  this.setLoading(true);
  return fetch('/cart.js', { cache: 'no-store' })
    .then((res) => res.json())
    .then((cart) => {
      this.renderCart(cart);
      return cart;
    })
    .catch(() => {
      this.showError(window.cartStrings ? window.cartStrings.error : 'Could not load cart.');
    })
    .finally(() => this.setLoading(false));
}

  updateLine(key, quantity) {
    if (!key) return;

    const row = this.itemsEl.querySelector(`[data-key="${key}"]`);
    if (row) row.classList.add('is-updating');
    this.clearError();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) || 0 }),
    })
      .then((res) => res.json())
      .then((cart) => {
        if (cart.status) {
          this.showError(cart.description || cart.message);
          return this.fetchCart();
        }
        this.renderCart(cart);
      })
      .catch(() => {
        this.showError(window.cartStrings ? window.cartStrings.error : 'Something went wrong.');
      });
  }

  renderCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:99:updated', { detail: cart }));

    this.activeCurrency = cart.currency;

    this.updateCartCount(cart.item_count);
    if (this.headerCountEl) this.headerCountEl.textContent = cart.item_count;

    this.bodyEl.classList.toggle('cart-flyout-99__body--empty', cart.item_count === 0);

    if (cart.item_count === 0) {
        this.itemsEl.innerHTML = '';
        this.emptyEl.hidden = false;
        this.footerEl.hidden = true;
        this.recommendationsEl.hidden = true;
        this.lastAddedKey = null;
        return;
    }

    this.emptyEl.hidden = true;
    this.footerEl.hidden = false;
    this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    this.refreshDynamicCheckout();

    const items = this.orderItems(cart.items);
    this.itemsEl.innerHTML = items.map((item) => this.itemTemplate(item)).join('');
    this.lastAddedKey = null;

    const seedId = this.lastSeedProductId || items[0].product_id;
    const seedSize = this.getSizeFromItem(items.find((i) => i.product_id === seedId) || items[0]);
    this.fetchRecommendations(seedId, seedSize);
    }

  orderItems(items) {
    if (!this.lastAddedKey) return items;
    const list = [...items];
    const index = list.findIndex((item) => item.key === this.lastAddedKey);
    if (index > 0) {
      const [added] = list.splice(index, 1);
      list.unshift(added);
    }
    return list;
  }

  refreshDynamicCheckout() {
    const source = document.getElementById('AdditionalCheckoutButtons99Source');
    const target = this.querySelector('#CartFlyout99-DynamicCheckout');
    if (!source || !target) return;

    // Move (not clone) the already-hydrated buttons into the flyout —
    // moving a live DOM node preserves any listeners Shopify's own
    // checkout-button script attached on page load.
    while (source.firstChild) {
      target.appendChild(source.firstChild);
    }
  }

  executeInjectedScripts(container) {
    const scripts = container.querySelectorAll('script');
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  getSizeFromItem(item) {
    if (!item || !item.options_with_values) return null;
    const sizeOption = item.options_with_values.find((o) => /size/i.test(o.name));
    return sizeOption ? sizeOption.value : null;
    }

    getColorFromItem(item) {
    if (!item || !item.options_with_values) return null;
    const colorOption = item.options_with_values.find((o) => /colou?r/i.test(o.name));
    return colorOption ? colorOption.value : null;
    }

    itemTemplate(item) {
    const color = this.getColorFromItem(item);
    const options = color ? `<div class="cart-flyout-99__item-options">[${color}]</div>` : '';

    const size = this.getSizeFromItem(item);
    const sizeHtml = size ? `<div class="cart-flyout-99__item-size">${size}</div>` : '';

    const image = item.image
        ? `<img class="cart-flyout-99__item-image" src="${item.image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2')}" alt="${this.escapeHtml(item.product_title)}" loading="lazy">`
        : '<div class="cart-flyout-99__item-image"></div>';

    return `
        <div class="cart-flyout-99__item" data-key="${item.key}">
        ${image}
        <div class="cart-flyout-99__item-details">
            <div class="cart-flyout-99__item-top">
            <a href="${item.url}" class="cart-flyout-99__item-title">${this.escapeHtml(item.product_title)}</a>
            <span class="cart-flyout-99__item-price">${this.formatMoney(item.final_line_price)}</span>
            </div>
            ${options}
            ${sizeHtml}
            <div class="cart-flyout-99__qty">
            <button type="button" data-qty-minus aria-label="Decrease quantity">&minus;</button>
            <input type="number" min="0" value="${item.quantity}" data-qty-input aria-label="Quantity">
            <button type="button" data-qty-plus aria-label="Increase quantity">&plus;</button>
            </div>
        </div>
        </div>
    `;
    }

  fetchRecommendations(productId, targetSize) {
    if (!productId) {
        this.recommendationsEl.hidden = true;
        return;
    }

    fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`)
      .then((res) => res.json())
      .then((data) => {
      const products = data.products || [];

      if (!products.length) {
          this.recommendationsEl.hidden = true;
          return;
      }

      return Promise.all(
          products.map((product) => {
          const cleanUrl = product.url.split('?')[0];
          return fetch(`${cleanUrl}.js`)
              .then((res) => {
              if (!res.ok) throw new Error(`${cleanUrl}.js returned ${res.status}`);
              return res.json();
              })
              .then((full) => ({ product, fullProduct: full }))
              .catch((err) => {
              console.error('[cart-flyout-99] failed to load variant for', cleanUrl, err);
              return null;
              });
          })
      ).then((results) => {
          const valid = results.filter((r) => r && r.fullProduct.variants.length);

          if (!valid.length) {
          this.recommendationsEl.hidden = true;
          return;
          }
          this.recommendationsListEl.innerHTML = valid
          .map(({ product, fullProduct }) => this.recommendationTemplate(product, fullProduct, targetSize))
          .join('');
          this.recommendationsEl.hidden = false;
      });
      })
      .catch((err) => {
      console.error('[cart-flyout-99] recommendations fetch failed:', err);
      this.recommendationsEl.hidden = true;
      });
  }

  matchVariant(fullProduct, targetSize) {
    if (!fullProduct.variants || !fullProduct.variants.length) return null;

    if (!targetSize || !fullProduct.options) {
      return fullProduct.variants.find((v) => v.available) || fullProduct.variants[0];
    }

    const sizeIndex = fullProduct.options.findIndex((option) => /size|größe|grösse/i.test(option.name));
    if (sizeIndex === -1) {
      return fullProduct.variants.find((v) => v.available) || fullProduct.variants[0];
    }

    const optionKey = `option${sizeIndex + 1}`;
    const matches = fullProduct.variants.filter((v) => v[optionKey] === targetSize);
    if (!matches.length) {
      return fullProduct.variants.find((v) => v.available) || fullProduct.variants[0];
    }

    return matches.find((v) => v.available) || matches[0];
  }

  recommendationTemplate(product, fullProduct, targetSize) {
    const cleanUrl = product.url.split('?')[0];
    const image = product.featured_image
        ? `<img class="cart-flyout-99__recommendation-image" src="${product.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2')}" alt="${this.escapeHtml(product.title)}" loading="lazy">`
        : '<div class="cart-flyout-99__recommendation-image"></div>';

    const sizeIndex = fullProduct.options.findIndex((option) => /size|größe|grösse/i.test(option.name));
    const hasSizeOption = sizeIndex !== -1 && fullProduct.variants.length > 1;

    let initialVariant = null;
    if (targetSize && hasSizeOption) {
      const optionKey = `option${sizeIndex + 1}`;
      initialVariant = fullProduct.variants.find((v) => v[optionKey] === targetSize && v.available);
    }
    if (!initialVariant) {
      initialVariant = fullProduct.variants.find((v) => v.available) || fullProduct.variants[0];
    }

    const sizePills = hasSizeOption
      ? `
        <div class="cart-flyout-99__recommendation-sizes" role="group" aria-label="Select size">
          ${fullProduct.variants.map((v) => {
            const sizeLabel = v.title !== 'Default Title' ? (v.public_title || v.title) : v.title;
            const isSelected = v.id === initialVariant.id;
            return `
              <button
                type="button"
                class="cart-flyout-99__recommendation-size-pill${isSelected ? ' is-selected' : ''}"
                data-select-variant
                data-variant-id="${v.id}"
                data-variant-price="${v.price}"
                data-variant-available="${v.available}"
                ${v.available ? '' : 'disabled'}
              >${this.escapeHtml(sizeLabel)}</button>
            `;
          }).join('')}
        </div>
      `
      : '';

    const buttonLabel = initialVariant.available ? 'Add' : 'Sold out';

    return `
        <div class="cart-flyout-99__recommendation" data-recommendation-product>
        <a href="${cleanUrl}">
            ${image}
        </a>
        <div class="cart-flyout-99__recommendation-details">
            <a href="${cleanUrl}" class="cart-flyout-99__recommendation-title">${this.escapeHtml(product.title)}</a>
            <span class="cart-flyout-99__recommendation-price" data-recommendation-price>${this.formatMoney(initialVariant.price)}</span>
            ${sizePills}
            <button
            type="button"
            class="cart-flyout-99__recommendation-add"
            data-add-recommendation
            data-variant-id="${initialVariant.id}"
            ${initialVariant.available ? '' : 'disabled'}
            >
            ${buttonLabel}
            </button>
        </div>
        </div>
    `;
  }

  updateCartCount(count) {
    document.querySelectorAll('[data-cart-flyout-99-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  formatMoney(cents) {
  const currencyCode = this.activeCurrency;

  if (currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
      }).format(cents / 100);
    } catch (e) {
      // fall through to legacy formatting below
    }
  }

  if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.moneyFormat) {
    return window.Shopify.formatMoney(cents, window.moneyFormat);
  }
  return '$' + (cents / 100).toFixed(2);
}

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  showError(message) {
    if (!message) return;
    this.errorsEl.textContent = message;
    this.errorsEl.hidden = false;
  }

  clearError() {
    this.errorsEl.hidden = true;
    this.errorsEl.textContent = '';
  }

  setLoading(state) {
    this.loadingEl.hidden = !state;
  }

  open() {
    window.SiteModal99.open('cart-flyout-99', () => this.close());
    this.classList.add('active');
    document.body.classList.add('cart-flyout-99-open');
    const panel = this.querySelector('.cart-flyout-99__panel');
    if (typeof trapFocus === 'function') trapFocus(panel);
    panel.focus();
    }

    close() {
    window.SiteModal99.close('cart-flyout-99');
    this.classList.remove('active');
    document.body.classList.remove('cart-flyout-99-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    }
}

customElements.define('cart-flyout-99', CartFlyout99);